export * from './AddCompanyModule'
export const addCompanyPath = '/et/company/:companyId/addCompanyModule'

